require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var a = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var a in e) {
      n.d(r, a, function (t) {
        return e[t];
      }.bind(null, a));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 2);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  e.exports = n(3)();
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(0),
      a = n.n(r),
      o = n(1),
      c = n.n(o);

  function i(e) {
    return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function l(e, t) {
    return !t || "object" !== i(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function u(e) {
    return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function s(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function f(e, t, n) {
    return t && s(e.prototype, t), n && s(e, n), e;
  }

  function m(e, t) {
    return (m = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var p = function p(e) {
    return Array.isArray(e) && e.length > 0;
  },
      v = function v(e) {
    return e && e instanceof Date && !isNaN(e.getTime());
  },
      d = function d(e) {
    return v(e) ? String(e.getFullYear()) : "-";
  },
      y = function y(e) {
    return a.a.createElement("svg", {
      className: "rt-dot",
      viewBox: "0 0 8 10"
    }, a.a.createElement("circle", {
      cx: "4",
      cy: "5",
      r: "3",
      stroke: "none"
    }));
  },
      b = function b(e) {
    return a.a.createElement("svg", {
      className: "rt-arrow",
      viewBox: "0 0 6 8"
    }, a.a.createElement("g", null, a.a.createElement("path", {
      d: "M 0 0 L 6 4 L 0 8 L 0 0"
    })));
  },
      g = function g(e) {
    var t = e.event;
    return a.a.createElement("div", {
      className: "rt-label"
    }, d(t.date));
  },
      E = function E(e) {
    var t = e.event;
    return a.a.createElement("div", {
      className: "rt-label"
    }, d(t.date));
  },
      h = function h(e) {
    var t = e.event,
        n = t.date,
        r = t.title;
    return a.a.createElement("div", null, a.a.createElement("h2", {
      className: "rt-title"
    }, r), a.a.createElement("p", {
      className: "rt-date"
    }, function (e) {
      if (!v(e)) return "-";
      var t = String(e.getDate()),
          n = String(e.getMonth() + 1),
          r = String(e.getFullYear());
      return "".concat(n.length > 1 ? n : "0" + n, "/").concat(t.length > 1 ? t : "0" + t, "/").concat(r);
    }(n)));
  },
      O = function O(e) {
    var t = e.event,
        n = t.buttonText,
        r = t.onClick;
    return a.a.createElement("button", {
      className: "rt-btn",
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault(), (r || function (e) {
          return e;
        })(e);
      }
    }, n || "");
  },
      N = function N(e) {
    var t = e.event.text;
    return a.a.createElement("div", null, a.a.createElement("p", null, t));
  },
      x = function x(e) {
    var t = e.event.imageUrl;
    return a.a.createElement("div", null, a.a.createElement("img", {
      src: t,
      alt: "",
      className: "rt-image"
    }));
  },
      S = function S(e) {
    return a.a.createElement("div", {
      className: "rt-svg-container"
    }, a.a.createElement(b, null), a.a.createElement(y, null));
  },
      _ = function _() {
    return a.a.createElement("li", {
      key: "clear",
      className: "rt-clear"
    });
  },
      P = function (e) {
    function t(e) {
      var n;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), (n = l(this, u(t).call(this, e))).state = n.getStateForProps(e), n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && m(e, t);
    }(t, r["Component"]), f(t, [{
      key: "getStateForProps",
      value: function value(e) {
        var t = e.events,
            n = e.reverseOrder;
        return p(t) ? {
          events: t.filter(function (e) {
            e.title;
            var t = e.date;
            return v(t);
          }).sort(function (e, t) {
            return n ? new Date(t.date) - new Date(e.date) : new Date(e.date) - new Date(t.date);
          })
        } : {
          events: []
        };
      }
    }]), f(t, [{
      key: "componentWillReceiveProps",
      value: function value(e) {
        this.setState(this.getStateForProps(e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.state.events;
        if (!e.length) return a.a.createElement("div", null);
        var t = this.props.customComponents || {},
            n = t.topLabel,
            r = t.bottomLabel,
            o = t.header,
            c = t.footer,
            i = t.imageBody,
            l = t.textBody,
            u = n || g,
            s = r || E,
            f = o || h,
            m = i || x,
            v = l || N,
            d = c || O;
        return a.a.createElement("div", {
          className: "rt-timeline-container"
        }, a.a.createElement("ul", {
          className: "rt-timeline"
        }, a.a.createElement("li", {
          key: "top",
          className: "rt-label-container"
        }, a.a.createElement(u, {
          event: function (e) {
            return p(e) ? e[0] : null;
          }(e)
        })), e.map(function (e, t) {
          return a.a.createElement("li", {
            className: "rt-event",
            key: t
          }, a.a.createElement("div", {
            className: "rt-backing"
          }, a.a.createElement(S, null), a.a.createElement("div", {
            className: "rt-content"
          }, a.a.createElement("div", {
            className: "rt-header-container"
          }, a.a.createElement(f, {
            event: e
          })), a.a.createElement("div", {
            className: "rt-image-container"
          }, a.a.createElement(m, {
            event: e
          })), a.a.createElement("div", {
            className: "rt-text-container"
          }, a.a.createElement(v, {
            event: e
          })), a.a.createElement("div", {
            className: "rt-footer-container"
          }, a.a.createElement(d, {
            event: e
          })))));
        }), a.a.createElement(_, null), a.a.createElement("li", {
          key: "bottom",
          className: "rt-label-container"
        }, a.a.createElement(s, {
          event: function (e) {
            return p(e) ? e[e.length - 1] : null;
          }(e)
        }))));
      }
    }]), t;
  }();

  P.displayName = "Timeline", P.propTypes = {
    events: c.a.arrayOf(c.a.shape({
      date: c.a.instanceOf(Date).isRequired,
      title: c.a.string.isRequired,
      imageUrl: c.a.string.isRequired,
      text: c.a.string.isRequired,
      onClick: c.a.func,
      buttonText: c.a.string,
      extras: c.a.object
    })).isRequired,
    customComponents: c.a.shape({
      topLabel: c.a.func,
      bottomLabel: c.a.func,
      header: c.a.func,
      imageBody: c.a.func,
      textBody: c.a.func,
      footer: c.a.func
    }),
    reverseOrder: c.a.bool
  }, t["default"] = P;
}, function (e, t, n) {
  "use strict";

  var r = n(4);

  function a() {}

  e.exports = function () {
    function e(e, t, n, a, o, c) {
      if (c !== r) {
        var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw i.name = "Invariant Violation", i;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t
    };
    return n.checkPropTypes = a, n.PropTypes = n, n;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}]);